export function onPopstateCaptured(handler) {
  window.addEventListener('popstate', handler, {
    capture: true
  });
  return () => window.removeEventListener('popstate', handler, {
    capture: true
  });
}